import { types } from 'mobx-state-tree';

import { fetchApiEndpoint } from './flows/get-api-endpoint';
import { loadable } from '../mobx-utils';

export const IncomingAgency = types.model('IncomingAgencyModel', {
  contact: types.maybeNull(types.string),
});

export const TravelAgency = types.model('TravelAgencyModel', {
  id: types.maybeNull(types.string),
  name: types.maybeNull(types.string),
  phone: types.maybeNull(types.string),
  email: types.maybeNull(types.string),
});

export const Contacts = types.model('ContactsModel', {
  incomingAgency: types.maybeNull(IncomingAgency),
  travelAgency: types.maybeNull(TravelAgency),
});

export const ContactStore = types.model('ContactStore', {
  contacts: loadable(Contacts, fetchApiEndpoint('/api/contacts')),
});
